<template>
  <div class="contact-customer-service-preview">
    <img :style="{height: `${$$FormData.image_size}px`,width:`${$$FormData.image_size}px`}" :src="$$FormData.background_image.src" alt="">
  </div>
</template>
<script>
export default {
  name:'ContactCustomerServicePreview',
  data(){
    return {}
  }
}
</script>

<style lang="scss" scoped>
.contact-customer-service-preview {
  position: sticky !important;
  left: 0;
  top: 50px;
}
</style>